export default __webpack_public_path__ + "static/media/Browns.f2b7dde2.png";